import React from "react";
import "./AnswerQuestions.scss";
import {
  WingBlank,
  Button,
  Progress,
  Radio,
  Toast,
  ActivityIndicator,
  Modal,
  TextareaItem
} from "antd-mobile";
import http from "../../util/api";
import { fixIOSWXBug } from "../../util/util";
import moment from "moment";

const resid2 = "607270079025"; // 考试批次答题表
const resid3 = "608809112309"; // 考试批次表

const totalSecond = 15 * 60; //考试总时长
const formatSeconds = value => {
  let secondTime = parseInt(value); // 秒
  let minuteTime = 0; // 分
  // let hourTime = 0; // 小时
  if (secondTime > 60) {
    //如果秒数大于60，将秒数转换成整数
    //获取分钟，除以60取整数，得到整数分钟
    minuteTime = parseInt(secondTime / 60);
    //获取秒数，秒数取佘，得到整数秒数
    secondTime = parseInt(secondTime % 60);
    //如果分钟大于60，将分钟转换成小时
    if (minuteTime > 60) {
      //获取小时，获取分钟除以60，得到整数小时
      // hourTime = parseInt(minuteTime / 60);
      //获取小时后取佘的分，获取分钟除以60取佘的分
      minuteTime = parseInt(minuteTime % 60);
    }
  }
  let result = "" + parseInt(secondTime) + "秒";

  if (minuteTime > 0) {
    result = "" + parseInt(minuteTime) + "分" + result;
  }
  // if (hourTime > 0) {
  //   result = "" + parseInt(hourTime) + "小时" + result;
  // }
  return result;
};

class AnswerQuestions extends React.Component {
  state = {
    paper: {}, //考试批次
    questionAnswers: [], // 考题数组
    currentQuestion: {}, // 当前考题
    currentQuestionNo: 1, // 当前考题序号
    isLoading: false,
    batchId: "",
    visible: false,
    isTestFinished: false,
    isAnsweringQuestion: false, // 是否正在答简答题
    shortQuestionNo: 1, // 当前简答题题序号
    shortQuestions: [], //
    startTimeUnix: 0,
    remainSecond: "", //剩余秒数
    isSubmitPersoninfo: true
  };
  async componentDidMount() {
    this.setState({ isLoading: true });
    try {
      //设置考试批次
      let batchId = this.props.match.params.id;
      if (batchId) {
        this.setState({ batchId });
        await this.getPaper(batchId);
        this.getQuestionAnswers(batchId);
        this.getShortQuestions(batchId);
        this.getInterview(batchId);
      } else {
        this.setState({ visible: true });
      }
      this.setState({ isLoading: false });
    } catch (error) {
      console.error(error);
      Toast.fail(error.message);
      this.setState({ isLoading: false });
    }
  }

  componentWillUnmount() {
    this.timer = null;
    this.caculateRemainSecond = null;
  }

  caculateRemainSecond = () => {
    let { remainSecond } = this.state;
    if (!this.caculateRemainSecond) {
      return;
    }
    if (--remainSecond <= 0) {
      this.setState({ remainSecond: 0 });
      Toast.loading("考试时间到，自动交卷中...", 0);
      this.getTestResult();
    } else {
      this.setState({ remainSecond });
      this.timer = setTimeout(this.caculateRemainSecond, 1000);
    }
  };

  getInterview = async batchId => {
    try {
      let res = await http().getTable({
        resid: "617190472818",
        cmswhere: `batchId = '${batchId}'`
      });
      const data = res.data.data[0];
      let remainSecond =
        totalSecond - (moment().unix() - moment(data.C3_617724261149).unix());
      this.setState(
        {
          remainSecond,
          isSubmitPersoninfo: data.C3_617294701291 === "Y" ? true : false
        },
        this.caculateRemainSecond
      );
    } catch (error) {
      console.log(error.message);
      Toast.fail(error.message);
    }
  };
  //获取考题
  getQuestionAnswers = async batchId => {
    try {
      let res = await http().getTable({
        resid: resid2,
        cmswhere: `C3_607174326853 = '${batchId}'`
      });
      let data = [...res.data.data];
      if (!data.length) {
        return Toast.info("无考题数据");
      }
      let index = data.findIndex(item => {
        return item.C3_607174361025 === null;
      });
      if (index === -1) {
        index = data.length - 1;
      }
      this.setState({
        questionAnswers: data,
        currentQuestion: data[index],
        currentQuestionNo: index + 1
      });
    } catch (error) {
      console.error(error);
      Toast.fail(error.message);
    }
  };

  // 获取简答题
  getShortQuestions = async batchId => {
    try {
      let res = await http().getTable({
        resid: 618313055686,
        cmswhere: `C3_618419320444 = '${batchId}'`
      });
      let data = [...res.data.data];
      let index = data.findIndex(item => {
        return item.C3_618313028667 === null;
      });
      if (index === -1) {
        index = data.length - 1;
      }
      this.setState({ shortQuestions: data, shortQuestionNo: index + 1 });
    } catch (error) {
      console.log(error);
      Toast.fail(error.message);
    }
  };

  //获取试卷
  getPaper = async batchId => {
    try {
      let res = await http().getTable({
        resid: resid3,
        cmswhere: `C3_607196596723 = '${batchId}'`
      });
      if (res.data.error === 0) {
        if (res.data.data.length) {
          if (res.data.data[0].C3_607198887973 === "Y") {
            this.setState({ isTestFinished: true });
          } else {
            this.setState({
              paper: res.data.data[0]
            });
          }
        } else {
          Toast.info("无试卷数据");
        }
      } else {
        Toast.fail(res.data.message);
      }
    } catch (error) {
      console.error(error);
      Toast.fail(error.data.Message);
    }
  };

  //点击答案选项
  setAnswer = answer => {
    let questionAnswers = [...this.state.questionAnswers],
      currentQuestion = { ...this.state.currentQuestion };
    currentQuestion.C3_607174361025 = answer;
    questionAnswers[this.state.currentQuestionNo - 1] = currentQuestion;
    this.setState({
      questionAnswers,
      currentQuestion
    });
  };

  setMultipleSelectionAnswer = (answer, isAdd = true) => {
    let questionAnswers = [...this.state.questionAnswers],
      currentQuestion = { ...this.state.currentQuestion };
    let multipleSelectionAnswer = new Set(currentQuestion.C3_607174361025);
    multipleSelectionAnswer.delete(" ");
    multipleSelectionAnswer.delete(",");
    if (isAdd) {
      multipleSelectionAnswer.add(answer);
    } else {
      multipleSelectionAnswer.delete(answer);
    }
    multipleSelectionAnswer = new Set(
      Array.from(multipleSelectionAnswer).sort()
    );
    let _answer = "";
    for (let item of multipleSelectionAnswer.keys()) {
      _answer += `${item} `;
    }
    _answer = _answer.trim();
    currentQuestion.C3_607174361025 = _answer;
    questionAnswers[this.state.currentQuestionNo - 1] = currentQuestion;
    this.setState({
      questionAnswers,
      currentQuestion
    });
    multipleSelectionAnswer = null;
  };

  //点击下一题提交答案
  submitAnswer = async () => {
    try {
      let res = await http().modifyRecords({
        resid: resid2,
        data: [
          {
            REC_ID: this.state.currentQuestion.REC_ID,
            C3_607174361025: this.state.currentQuestion.C3_607174361025
          }
        ]
      });
      if (res.data.Error === 0) {
        console.log(res.data.data);
      } else {
        console.error(res.data.message);
      }
    } catch (error) {
      console.error(error);
      Toast.fail(error.data.message);
    }
  };

  //提交简答题答案
  submitShortAnswer = async data => {
    try {
      let res = await http().modifyRecords({
        resid: 618313055686,
        data: [data]
      });
    } catch (error) {
      console.error(error);
      Toast.fail(error.message);
    }
  };
  //获取试卷结果
  getTestResult = async () => {
    const { isSubmitPersoninfo } = this.state;
    try {
      let res = await http().modifyRecords({
        resid: resid3,
        data: [
          {
            C3_607196596723: this.state.batchId,
            C3_607198887973: "Y",
            REC_ID: this.state.paper.REC_ID
          }
        ]
      });
      if (res.data.data.length) {
        Toast.hide();
        this.props.history.push("/test_result", {
          isPass: res.data.data[0].C3_610125942554,
          score: res.data.data[0].C3_608755560466,
          interviewId: res.data.data[0].C3_607196596723,
          isSubmitPersoninfo
        });
      } else {
        Toast.info("无结果");
      }
    } catch (error) {
      console.error(error);
      Toast.fail(error.message);
    }
  };

  answerShort = async () => {
    let { shortQuestionNo, shortQuestions } = this.state;
    if (
      !shortQuestions[shortQuestionNo - 1].C3_618313028667 ||
      !shortQuestions[shortQuestionNo - 1].C3_618313028667.trim()
    ) {
      return Toast.info("请先回答问题哦", 1);
    }
    if (shortQuestions[shortQuestionNo - 1].C3_618313028667.trim().length < 5) {
      return Toast.info("答案不能少于5个字", 1);
    }
    Toast.loading("请稍等...", 0);
    await this.submitShortAnswer(shortQuestions[shortQuestionNo - 1]);
    this.setState({
      shortQuestionNo: shortQuestionNo + 1
    });
    Toast.hide();
  };

  submitShort = async () => {
    let { shortQuestionNo, shortQuestions } = this.state;
    if (
      !shortQuestions[shortQuestionNo - 1].C3_618313028667 ||
      !shortQuestions[shortQuestionNo - 1].C3_618313028667.trim()
    ) {
      return Toast.info("请先回答问题哦", 1);
    }
    if (shortQuestions[shortQuestionNo - 1].C3_618313028667.trim().length < 5) {
      return Toast.info("答案不能少于5个字", 1);
    }
    Toast.loading("请稍等...", 0);
    this.submitShortAnswer(shortQuestions[shortQuestionNo - 1]);
    await this.getTestResult();
    Toast.hide();
  };

  render() {
    let { currentQuestion, isLoading } = this.state;
    return isLoading ? (
      <ActivityIndicator
        toast
        text="正在生成试卷..."
        animating={this.state.isLoading}
      />
    ) : (
      <div className="answer_questions">
        {this.state.isAnsweringQuestion ? (
          <div className="answer_questions_wrapper">
            <div className="answer_questions-progress">
              <div className="answer_questions-progress-tips">
                <span>简答题进度</span>
                <span style={{ color: "rgba(16,152,236,1)" }}>
                  {this.state.shortQuestionNo}/{" "}
                  {this.state.shortQuestions.length}
                </span>
              </div>
              <div className="answer_questions-progress-progress_bar">
                <Progress
                  position="normal"
                  percent={Math.floor(
                    (this.state.shortQuestionNo /
                      this.state.shortQuestions.length) *
                      100
                  )}
                  style={{
                    border: "1px solid rgba(221,221,221,1)",
                    borderRadius: 4,
                    background: "rgba(247, 247, 247, 1)"
                  }}
                  barStyle={{
                    border: "1px solid rgba(221,221,221,1)"
                  }}
                />
              </div>
              <div className="answer_questions-progress-remain_time">
                剩余时间：{formatSeconds(this.state.remainSecond)}
              </div>
            </div>
            <div className="short_question_and_answer">
              <div className="short_question">
                {
                  this.state.shortQuestions[this.state.shortQuestionNo - 1]
                    .C3_618313023953
                }
              </div>
              <div className="short_answer">
                <TextareaItem
                  clear
                  rows={10}
                  placeholder="请输入你的回答,不少于5个字"
                  value={
                    this.state.shortQuestions[this.state.shortQuestionNo - 1]
                      .C3_618313028667
                  }
                  onChange={val => {
                    let { shortQuestions, shortQuestionNo } = this.state;
                    shortQuestions[shortQuestionNo - 1].C3_618313028667 = val;
                    this.setState({
                      shortQuestions
                    });
                  }}
                  onBlur={fixIOSWXBug}
                />
              </div>
            </div>
            <div className="answer_questions-actions">
              <WingBlank>
                {this.state.shortQuestionNo === 1 ? (
                  <Button
                    type="primary"
                    className="action_btn"
                    onClick={() => {
                      this.setState({ isAnsweringQuestion: false });
                    }}
                  >
                    回到选择题
                  </Button>
                ) : (
                  <Button
                    type="primary"
                    disabled={this.state.shortQuestionNo === 1}
                    className="action_btn"
                    onClick={() => {
                      this.setState({
                        shortQuestionNo: this.state.shortQuestionNo - 1
                      });
                    }}
                  >
                    上一题
                  </Button>
                )}
                {this.state.shortQuestionNo ===
                this.state.shortQuestions.length ? (
                  <Button
                    type="primary"
                    className="action_btn"
                    onClick={this.submitShort}
                  >
                    提交
                  </Button>
                ) : (
                  <Button
                    type="primary"
                    className="action_btn"
                    onClick={this.answerShort}
                  >
                    下一题
                  </Button>
                )}
              </WingBlank>
            </div>
          </div>
        ) : (
          <div className="answer_questions_wrapper">
            <div className="answer_questions-progress">
              <div className="answer_questions-progress-tips">
                <span>答题进度</span>
                <span style={{ color: "rgba(16,152,236,1)" }}>
                  {this.state.currentQuestionNo}/
                  {this.state.questionAnswers.length}
                </span>
              </div>
              <div className="answer_questions-progress-progress_bar">
                <Progress
                  position="normal"
                  percent={Math.floor(
                    (this.state.currentQuestionNo /
                      this.state.questionAnswers.length) *
                      100
                  )}
                  style={{
                    border: "1px solid rgba(221,221,221,1)",
                    borderRadius: 4,
                    background: "rgba(247, 247, 247, 1)"
                  }}
                  barStyle={{
                    border: "1px solid rgba(221,221,221,1)"
                  }}
                />
              </div>
              <div className="answer_questions-progress-remain_time">
                剩余时间：{formatSeconds(this.state.remainSecond)}
              </div>
            </div>
            <div className="answer_questions-question_and_ansers">
              <div className="question">
                <p>
                  {this.state.currentQuestionNo}、{" "}
                  {currentQuestion.C3_607174324806}
                </p>
              </div>
              {currentQuestion.C3_607174325447 === "单选题" && (
                <div className="answers">
                  <Radio
                    className="my-radio"
                    checked={"A" === currentQuestion.C3_607174361025}
                    onClick={() => {
                      this.setAnswer("A");
                    }}
                  >
                    A、{currentQuestion.C3_610631530894}
                  </Radio>
                  <Radio
                    className="my-radio"
                    checked={"B" === currentQuestion.C3_607174361025}
                    onClick={() => {
                      this.setAnswer("B");
                    }}
                  >
                    B、{currentQuestion.C3_610631540660}
                  </Radio>
                  <Radio
                    className="my-radio"
                    checked={"C" === currentQuestion.C3_607174361025}
                    onClick={() => {
                      this.setAnswer("C");
                    }}
                  >
                    C、{currentQuestion.C3_610631550971}
                  </Radio>
                  <Radio
                    className="my-radio"
                    checked={"D" === currentQuestion.C3_607174361025}
                    onClick={() => {
                      this.setAnswer("D");
                    }}
                  >
                    D、{currentQuestion.C3_610631559052}
                  </Radio>
                </div>
              )}
              {currentQuestion.C3_607174325447 === "判断题" && (
                <div className="answers">
                  <Radio
                    className="my-radio"
                    checked={"Y" === currentQuestion.C3_607174361025}
                    onClick={() => {
                      this.setAnswer("Y");
                    }}
                  >
                    对
                  </Radio>
                  <Radio
                    className="my-radio"
                    checked={"N" === currentQuestion.C3_607174361025}
                    onClick={() => {
                      this.setAnswer("N");
                    }}
                  >
                    错
                  </Radio>
                </div>
              )}
              {currentQuestion.C3_607174325447 === "多选题" && (
                <div className="answers">
                  <Radio
                    className="my-radio"
                    checked={
                      currentQuestion.C3_607174361025 &&
                      currentQuestion.C3_607174361025.includes("A")
                    }
                    onClick={() => {
                      if (
                        currentQuestion.C3_607174361025 &&
                        currentQuestion.C3_607174361025.includes("A")
                      ) {
                        this.setMultipleSelectionAnswer("A", false);
                      } else {
                        this.setMultipleSelectionAnswer("A");
                      }
                    }}
                  >
                    A、{currentQuestion.C3_610631530894}
                  </Radio>
                  <Radio
                    className="my-radio"
                    checked={
                      currentQuestion.C3_607174361025 &&
                      currentQuestion.C3_607174361025.includes("B")
                    }
                    onClick={() => {
                      if (
                        currentQuestion.C3_607174361025 &&
                        currentQuestion.C3_607174361025.includes("B")
                      ) {
                        this.setMultipleSelectionAnswer("B", false);
                      } else {
                        this.setMultipleSelectionAnswer("B");
                      }
                    }}
                  >
                    B、{currentQuestion.C3_610631540660}
                  </Radio>
                  <Radio
                    className="my-radio"
                    checked={
                      currentQuestion.C3_607174361025 &&
                      currentQuestion.C3_607174361025.includes("C")
                    }
                    onClick={() => {
                      if (
                        currentQuestion.C3_607174361025 &&
                        currentQuestion.C3_607174361025.includes("C")
                      ) {
                        this.setMultipleSelectionAnswer("C", false);
                      } else {
                        this.setMultipleSelectionAnswer("C");
                      }
                    }}
                  >
                    C、{currentQuestion.C3_610631550971}
                  </Radio>
                  <Radio
                    className="my-radio"
                    checked={
                      currentQuestion.C3_607174361025 &&
                      currentQuestion.C3_607174361025.includes("D")
                    }
                    onClick={() => {
                      if (
                        currentQuestion.C3_607174361025 &&
                        currentQuestion.C3_607174361025.includes("D")
                      ) {
                        this.setMultipleSelectionAnswer("D", false);
                      } else {
                        this.setMultipleSelectionAnswer("D");
                      }
                    }}
                  >
                    D、{currentQuestion.C3_610631559052}
                  </Radio>
                </div>
              )}
            </div>
            <div className="answer_questions-actions">
              <WingBlank>
                <Button
                  type="primary"
                  disabled={this.state.currentQuestionNo === 1}
                  className="action_btn"
                  onClick={() => {
                    this.setState({
                      currentQuestionNo: this.state.currentQuestionNo - 1,
                      currentQuestion: {
                        ...this.state.questionAnswers[
                          this.state.currentQuestionNo - 2
                        ]
                      }
                    });
                  }}
                >
                  上一题
                </Button>
                {this.state.currentQuestionNo ===
                this.state.questionAnswers.length ? (
                  <Button
                    type="primary"
                    className="action_btn"
                    onClick={async () => {
                      if (!currentQuestion.C3_607174361025) {
                        return Toast.info("请选择答案", 1);
                      }
                      Toast.loading("请稍等...", 0);
                      await this.submitAnswer();
                      this.setState({ isAnsweringQuestion: true }, () =>
                        Toast.hide()
                      );
                    }}
                  >
                    进入简答题
                  </Button>
                ) : (
                  <Button
                    type="primary"
                    className="action_btn"
                    disabled={!this.state.questionAnswers.length}
                    onClick={async () => {
                      let questionAnswers = [...this.state.questionAnswers],
                        currentQuestionNo = this.state.currentQuestionNo;
                      if (!currentQuestion.C3_607174361025) {
                        return Toast.info("请选择答案", 1);
                      }
                      Toast.loading("请稍等...", 0);
                      await this.submitAnswer();
                      this.setState(
                        {
                          currentQuestionNo: this.state.currentQuestionNo + 1, // 答题序号加1
                          currentQuestion: {
                            ...this.state.questionAnswers[currentQuestionNo]
                          }, //下一个题目
                          questionAnswers
                        },
                        () => Toast.hide()
                      );
                    }}
                  >
                    下一题
                  </Button>
                )}
              </WingBlank>
            </div>
          </div>
        )}
        <Modal
          visible={this.state.visible}
          title="提示"
          transparent
          maskClosable={false}
          footer={[
            {
              text: "知道了",
              onPress: () => {
                this.setState({ visible: false });
                this.props.history.push("/scan_qrcode");
              }
            }
          ]}
        >
          无考试批次,请先扫码签到
        </Modal>
        <Modal
          visible={this.state.isTestFinished}
          title="提示"
          transparent
          maskClosable={false}
          footer={[
            {
              text: "知道了",
              onPress: () => {
                this.setState({ visible: false });
                this.props.history.push("/home");
              }
            }
          ]}
        >
          考试已结束
        </Modal>
      </div>
    );
  }
}

export default AnswerQuestions;
